import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TestCancelDialog } from '../../0_presentation/test/components/testDialogs';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { Test } from '../../2_domain/test/test';
// import IUserRepository from '../../2_domain/user/iUserRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';
import useDialog from '../core/components/feedback/useDialog';
import { TestDownloadDialog } from '../../0_presentation/test/components/testDownload';

const useTestDetailPageController = (test: Test) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');
  // const userRepo = Get.find<IUserRepository>('IUserRepository');
  const dialog = useDialog();
  const navigate = useNavigate();
  const [lang, setLanguage] = useState<any>({
    value: 'id',
  });

  const [plain, setPlain] = useState(false);

  const onManage = (type: 'Cancel') => {
    if (type === 'Cancel') {
      dialog.openDialog(
        <TestCancelDialog
          test={test}
          onCancel={async (reason) => {
            await promiseResolver({
              promise: testRepo.cancelTest(test.id, reason),
              successCallback: () => navigate(0),
            });
            dialog.closeDialog();
          }}
          onGoBack={async () => {
            dialog.closeDialog();
          }}
        ></TestCancelDialog>
      );
    } else {
      // eslint-disable-next-line no-throw-literal
      throw 'invalid manage type';
    }
  };

  const onDownloadReportHandler = async () => {
    dialog.openDialog(
      <TestDownloadDialog
        test={test}
        language={lang}
        plain={plain}
        onDownload={async (language: any, plain: any) => {
          await promiseResolver({
            promise: testRepo.getResultPDF(test.id, language.value, plain),
            successCallback: (data) => {
              const decode = (str: string): string =>
                Buffer.from(str, 'base64').toString('binary');
              window.open(decodeURIComponent(decode(data.test?.data)));
              dialog.closeDialog();
            },
            errorCallback: (error) => {
              dialog.closeDialog();
            },
          });
        }}
        onGoBack={async () => {
          dialog.closeDialog();
        }}
      ></TestDownloadDialog>
    );
  };

  const setLang = (language: any) => {
    setLanguage({ value: language });
  };

  const setPlains = (plain: any) => {
    setPlain(plain);
  };

  return {
    test,
    onManage,
    onDownloadReportHandler,
    setLang,
    setPlains,
    lang,
    plain,
  };
};

export default useTestDetailPageController;
